import { createActionCreator } from "deox";

export const acknowledgedBookingOnHoldMessage = createActionCreator(
  "acknowledgeBookingOnHoldMessage",
  (resolve) => (onHoldMessageAcknowledged: boolean) => resolve({ onHoldMessageAcknowledged })
);
